import script from "./AdminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=5030f05c&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5030f05c"]])

export default __exports__